import { Ship, Calendar, ArrowUpDown, ChevronRight, MoreHorizontal } from "lucide-react";
import moment from "moment";
import actionFinder from "../../utils/actionFinder";
import { IconSortAscending, IconSortDescending } from "@tabler/icons-react";
import { useEffect } from "react";
import { toggleSnackbar } from "../../redux/reducers/optionsReducers";

const LastInspection = ({ result, page, setPage, type, sort, setSort }) => {

  const handlePageNext = () => {
    if(page >= result?.totalPages - 1) {
      return;
    }
    setPage(page + 1);
  }

  const handlePagePrevious = () => {
    if(page > 0) {
      setPage(page - 1);
    }
  }

  const handleSort =()=>{
    setSort((state)=> state === "asc" ? "desc" : "asc")
  }

  return (
    <div className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden h-full flex flex-col">
      <div className="p-5 border-b border-slate-100">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-lg font-semibold text-slate-800">Recent Updated</h2>
            <p className="text-slate-500 text-xs mt-1">{type === "action" ? 'Vessel Inspection Actions' : 'Vessel Inspection Comments'}</p>
          </div>
        </div>
      </div>
      
      {
        result?.totalItems > 0 ? 
        <>
          <div className="overflow-x-auto flex-grow">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50">
                  <th className="px-10 py-4 text-left text-xs font-medium text-slate-500 tracking-wider">
                    <div className="flex items-center">
                      Vessel
                    </div>
                  </th>
                  <th className="px-10 py-4 flex justify-end text-xs font-medium text-slate-500 tracking-wider">
                    <button
                    className="flex items-center gap-2"
                    onClick={handleSort}
                    >
                      Inspection
                      {
                        sort === "asc" ?
                        <IconSortAscending size={16} color="#64748b" />:
                        <IconSortDescending size={16} color="#64748b" />
                      }
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {result?.items?.map((inspection, index) => {
                  const { action, color } = actionFinder(inspection);
                  return(
                    <tr 
                    key={index} 
                    className="hover:bg-slate-50 transition-colors duration-150"
                    >
                      <td className="px-10 py-3">
                        <div className="flex items-center">
                          <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-3">
                            <Ship className="h-4 w-4 text-indigo-600" />
                          </div>
                          <div>
                            <p className="font-semibold text-xs text-slate-800">{inspection?.inspection_history?.vessel?.name}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-10 py-3 flex justify-end">
                        <div>
                          <div className="flex items-center justify-end text-xs text-slate-600">
                            <Calendar className="h-3 w-3 text-slate-400 mr-1" />
                            {moment(inspection?.inspection_history?.due_date).format("MMM DD, YYYY")}
                          </div>
                          <div className="text-[11px] text-slate-500 mt-1">
                            Last action: {moment(inspection?.updatedAt).format("MMM DD, YYYY, hh:mm A")}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          
          <div className="p-4  px-10 border-t border-slate-100 bg-slate-50">
            <div className="flex justify-between items-center text-xs text-slate-500">
              <span>Showing {result?.currentPage * 5 + 1} to {result?.currentPage * 5 + result?.currentSize} of {result?.totalItems}</span>
              <div className="flex space-x-1">
                <button onClick={handlePagePrevious} className="px-2 py-1 bg-white border border-slate-200 rounded hover:bg-slate-100">Previous</button>
                <button onClick={handlePageNext} className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">Next</button>
              </div>
            </div>
          </div>
        </>:
        <div className="flex flex-col items-center justify-center h-full py-10">
          <div className="flex items-center justify-center">
            <MoreHorizontal className="h-8 w-8 text-slate-400" />
          </div>
          <p className="text-center text-sm text-slate-500 mt-4">No recent inspections found</p>
          <p className="text-center text-xs text-slate-400 mt-2">Please check back later</p>
        </div>
      }
    </div>
  );
}

export default LastInspection;